import axiosInstance from "./axiosInstance";
import { AxiosResponse } from 'axios';

import { TransferFundsType } from "@/types/binance";
import { Account } from "@/types/user";

export class BinanceService {
  private static readonly GET_ALL_ACCOUNT_ENDPOINT = 'app/users/subaccounts';
  private static readonly CREATE_TRANSFER_FUNDS_ENDPOINT = 'app/users/binance/transfer-funds';

  public static async getAllAccount(): Promise<Account[]> {
    const res: AxiosResponse<Account[]> = await axiosInstance.get(BinanceService.GET_ALL_ACCOUNT_ENDPOINT);
    return res.data;
  }

  public static async createTransferFunds(data: TransferFundsType): Promise<any> {
    const res: AxiosResponse<TransferFundsType> = await axiosInstance.post(BinanceService.CREATE_TRANSFER_FUNDS_ENDPOINT, data);
    return res.data;
  }
}
